import { LicenceResponse } from "./LicenceResponse";

export class LicenceMasterData {
    public verticalName: string = "";
    public licenceResponse: LicenceResponse[] = [];
}
